import { ReactNode } from "react";
import Modal from 'react-bootstrap/Modal';

type ModalType = {
    children: ReactNode;
    active: boolean;
    setActive: (value: boolean) => void;
    image?: string;
    background?: string;
}

const BubbleModal = ({ children, active, setActive }: ModalType) => {

    const handleClose = () => setActive(false);

    return (
        <Modal
            show={active}
            onHide={handleClose}
            backdrop="static"
            className="bubble-modal"
        >
            <Modal.Body className="container">
                <div className="row justify-content-center w-100">
                    <div className="col-12 col-md-10 col-lg-8 col-xl-6 d-flex flex-column align-items-center">
                        {children}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default BubbleModal;